import { MappingInfo, TargetField } from '../../../../../interfaces/Mapping';
import MappingColumnCard from './MappingColumnCard';

interface ManageMappingColumnCardsProps {
	mappedColumns: MappingInfo[];
	previewFileRows: any[];
	onColumnMapped: (id: number, value: string) => void;
	onHeaderColumnMapped: (id: number, value: string) => void;
	columnCardsToHide: MappingInfo[];
	processStatus: number;
	columnsHeaders: MappingInfo[];
	targetFields: TargetField[];
	onDeleteColumnCards: (id: number, value: string) => void;
}

const ManageMappingColumnCards = (props: ManageMappingColumnCardsProps) => {
	const {
		processStatus,
		columnsHeaders,
		targetFields,
		mappedColumns,
		previewFileRows,
		onColumnMapped,
		onHeaderColumnMapped,
		columnCardsToHide,
		onDeleteColumnCards,
	} = props;

	const hideColumn = (column: MappingInfo): boolean => {
		const isColumnMapped = columnCardsToHide.find(
			columnToHide =>
				columnToHide.sourceField.toLowerCase() === column.sourceField.toLowerCase() && columnToHide.targetField !== ''
		);
		return isColumnMapped !== undefined;
	};

	return (
		<div className='scrollbox'>
			<div className='list'>
				{mappedColumns.map(
					column =>
						!hideColumn(column) && (
							<MappingColumnCard
								key={column.id}
								processStatus={processStatus}
								onDeleteColumnCard={() => onDeleteColumnCards(column.id, column.sourceField)}
								targetFields={targetFields}
								columnMapping={column}
								columnsHeaders={columnsHeaders}
								previewColumnRows={previewFileRows.map(row => row[column.sourceField])}
								onFieldSelection={targetField => onColumnMapped(column.id, targetField)}
								onSourceFieldSelection={sourceField => onHeaderColumnMapped(column.id, sourceField)}
							/>
						)
				)}
			</div>
		</div>
	);
};

export default ManageMappingColumnCards;
